import { Alert, Button, Icon, Text } from "@alpacahq/ui/old";

import { FAQ } from "~/v2/components/common/FAQ";
import { Layout } from "../../../common/Layout";
import { ACH_FAQ } from "../achFaq";
import { type PlaidStatus, PlaidStatusPanel } from "../PlaidStatusPanel.pres";

export interface PlaidOAuthReturnPresentationProps {
  status: PlaidStatus;
  isPlaidReady: boolean;
  isVerifyingMicroDeposit: boolean;
  onOpenPlaid: () => void;
  onBack: () => void;
}

export const PlaidOAuthReturnPresentation = ({
  status,
  isPlaidReady,
  isVerifyingMicroDeposit,
  onOpenPlaid,
  onBack,
}: PlaidOAuthReturnPresentationProps) => {
  return (
    <Layout
      title="Direct Bank Transfer (ACH)"
      subtitle="Resuming your secure bank connection through Plaid."
      faq={<FAQ faq={ACH_FAQ} />}
    >
      <Button onClick={onBack} variant="secondary" className="mb-8">
        <Icon name="ArrowLeftCircle" className="mr-2" /> Back
      </Button>

      <Text className="pb-4 font-semibold text-xl">Plaid Connection</Text>

      <Alert
        className="mb-4"
        message={
          <span className="flex gap-4">
            <Icon name="InformationCircle" />
            <span>
              Note: Your bank account needs to <b>match</b> the name of your
              Alpaca brokerage account.
            </span>
          </span>
        }
        variant="info"
      />

      <PlaidStatusPanel
        status={status}
        isPlaidReady={isPlaidReady}
        isVerifyingMicroDeposit={isVerifyingMicroDeposit}
        // The resume page never shows the "already linked" terminal state — it
        // exists solely to continue an in-flight OAuth Link session.
        showAlreadyLinked={false}
        // The full-screen block is a pre-flight gate on the fresh-link page. A
        // user who has already authorized at their bank must not be blocked
        // here, or the in-flight resume would be stranded.
        isFullscreen={false}
        onOpenPlaid={onOpenPlaid}
        onBack={onBack}
      />
    </Layout>
  );
};
